import Swal from 'sweetalert2'

// Copia o link para a area de transferencia. Existe porque `compartilhar()` chamava `copiarLink` sem que ela existisse
// em lugar nenhum: o WebView do app Android nao tem `navigator.share`, caia nesse plano B e estourava
// "ReferenceError: copiarLink is not defined" logo depois de finalizar o pedido.
// NUNCA lanca erro: se nenhuma forma de copiar funcionar, devolve false (e, se `avisar`, mostra o link na tela).
export async function copiarLink(url, { avisar = false } = {}) {
  let copiado = false

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url)
      copiado = true
    }
  } catch (err) {
    // sem permissao / sem gesto do usuario: tenta o plano B abaixo
  }

  if (!copiado) {
    try {
      const area = document.createElement('textarea')
      area.value = url
      area.setAttribute('readonly', '')
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      area.setSelectionRange(0, url.length)
      copiado = document.execCommand('copy')
      document.body.removeChild(area)
    } catch (err) {
      copiado = false
    }
  }

  // `avisar` so no clique do botao Compartilhar. Logo depois de finalizar o pedido NAO avisa: ja existe o aviso
  // "Pedido Finalizado" na tela, e um segundo aviso o taparia.
  if (avisar) {
    Swal.fire(copiado
      ? { icon: 'success', title: 'Link copiado', text: 'Cole o link no WhatsApp para enviar o pedido.' }
      : { icon: 'info', title: 'Link do pedido', text: url })
  }
  return copiado
}
